<div class="service-detail-page">
    <div class="container">

        <header appFadeInReveal>
            <h1>Terapia para Adolescentes</h1>
            <div class="header-description">
                <p class="lead-text">
                    Ser adolescente no es fácil. Es una etapa llena de cambios, de presión, de decisiones importantes y,
                    a veces, de sentirse perdido o incomprendido.
                </p>
                <p>
                    En este espacio terapéutico, el objetivo es acompañar. Ofrezco un lugar donde poder hablar con
                    libertad, cuestionar, enfadarse, emocionarse o simplemente ser.
                </p>
                <p>
                    La terapia puede ayudar a entender lo que pasa por dentro, ponerle nombre a lo que cuesta y
                    encontrar formas más sanas de relacionarse consigo mismo y con los demás.
                </p>
                <p>
                    En ese proceso la familia es muy importante, por ello trabajamos coordinados. El acompañamiento a
                    padres y madres es parte del proceso: para comprender lo que está ocurriendo, mejorar la
                    comunicación y fortalecer el vínculo desde una mirada compartida y respetuosa.
                </p>
            </div>
            <p class="intro-text">
                ¿Cuándo puede ser útil la terapia en la adolescencia?
            </p>
        </header>

        <section appFadeInReveal>
            <p>La terapia puede acompañar a un adolescente que:</p>
            <ul class="check-list">
                <li>Siente ansiedad o emociones muy intensas.</li>
                <li>Tiene dificultades para gestionar frustración o enfado.</li>
                <li>Vive conflictos familiares o sociales.</li>
                <li>Se siente aislado, inseguro o con baja autoestima.</li>
                <li>Experimenta cambios bruscos de humor.</li>
                <li>Tiene problemas relacionadas con redes sociales o imagen corporal.</li>
                <li>Está pasando por una separación familiar, duelo o cambio importante.</li>
                <li>Tiene dificultades en la escuela o bajo rendimiento.</li>
                <li>Muestra tristeza persistente o pérdida de interés.</li>
            </ul>
        </section>

        <section appFadeInReveal>
            <div class="content-block">
                <div class="image">
                    <img src="/services_02.webp" alt="Terapia adolescentes Santander" class="photo--mask"
                        fetchpriority="high">
                </div>
                <div class="text">
                    <h2>¿Cómo se trabaja con adolescentes y niños?</h2>
                    <p>Adapto el proceso a su forma de ser y a su lenguaje:</p>
                    <ul class="check-list">
                        <li>En niños, uso juego, dibujo, cuentos y expresión creativa.</li>
                        <li>En adolescentes, trabajo desde una comunicación cercana, respetuosa y clara.</li>
                        <li>Con ambos, la familia forma parte del proceso, con orientación y pautas cuando es necesario.
                        </li>
                    </ul>
                </div>
            </div>
        </section>

        <section appFadeInReveal>
            <div class="content-block reverse">
                <div class="image">
                    <img src="/services_title_02.webp" alt="Consulta psicología familiar" class="photo--mask">
                </div>
                <div class="text">
                    <h2>¿Qué papel tiene la familia?</h2>
                    <p>
                        La familia es una parte fundamental en procesos infantiles y adolescentes.
                        Tendremos sesiones periódicas para compartir orientación, acompañamiento y
                        herramientas que ayuden al menor en su día a día.
                    </p>
                </div>
            </div>
        </section>

        <section appFadeInReveal>
            <h2>Beneficios del proceso terapéutico</h2>
            <p>La terapia puede ayudarle a:</p>
            <ul class="check-list">
                <li>Gestionar emociones de forma más sana.</li>
                <li>Mejorar su autoestima.</li>
                <li>Desarrollar una identidad más clara.</li>
                <li>Aumentar seguridad en sí mismo.</li>
                <li>Reducir ansiedad o tristeza.</li>
                <li>Mejorar relaciones con familia y amigos.</li>
                <li>Sentirse más comprendido y acompañado.</li>
                <li>Aprender herramientas útiles para el presente y el futuro.</li>
            </ul>
        </section>

        <div class="cta-container" appFadeInReveal>
            <a routerLink="/contacto" class="btn-primary">Pedir Cita</a>
        </div>

    </div>
</div>